import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import NotificationService from "../../services/notificationService";

const useFetch = (range) => {
  const [notifications, setNotifications] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const query = {
        startDate: range.start,
        endDate: range.end
      };

      const result = await NotificationService.loadNotifications(query);
      setNotifications(result);
    };
    fetchData();
  }, [range.end, range.start]);
  return { notifications };
};

const DashboardNotificationCenter = ({ range }) => {
  const { notifications } = useFetch(range);

  return (
    <div className="content-wrapper" style={{ height: "100%" }}>
      <ul className="notification-list">
        {notifications.length ? (
          notifications.map((notification, i) => (
            <li
              key={i}
              className={[
                "notification-list-item",
                notification.size || ""
              ].join(" ")}
            >
              {notification.text}
            </li>
          ))
        ) : (
          <li>No notifications.</li>
        )}
      </ul>
    </div>
  );
};

DashboardNotificationCenter.propTypes = {
  range: PropTypes.object
};
DashboardNotificationCenter.defaultProps = {
  range: {}
};
export default DashboardNotificationCenter;
